export default __webpack_public_path__ + "assets/images/0cc7f0dabdb995986cdb9c6e72511394.png";